<template>
  <div class="webmaster_popup_box" @click="closeEvent">
    <div
      class="webmaster_popup_item"
      @click.stop="noBubbles"
      :style="{ width: contentWidth }"
    >
      <div class="webmaster_popup_close" @click.stop="closeEvent">
        <i class="el-icon-close"></i>
      </div>
      <div class="webmaster_popup_title" v-text="popTitle"></div>
      <div class="webmaster_popup_body">
        <slot name="webmaster_popup"></slot>
      </div>
      <div
        class="webmaster_popup_opra"
        :class="popOpraBtns && popOpraBtns.length === 1 ? 'onlyBtn' : ''"
        v-if="popOpraBtns && popOpraBtns.length > 0"
      >
        <span
          class="opraBtn"
          v-for="item in popOpraBtns"
          :key="item.btnTitle"
          @click="item.btnEvent"
          :style="item.btnStyle"
          v-text="item.btnTitle"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 内容宽度
    contentWidth: {
      type: String,
      default: '56%',
    },
    // 用于关闭弹窗的事件  回调函数
    closeEvent: {
      type: Function,
    },
    popTitle: {
      type: String,
      default: '弹窗标题',
    },
    popOpraBtns: {
      type: Array,
      default: () => {
        return [
          {
            btnTitle: '取消',
            btnEvent: () => {},
            btnStyle: '',
          },
          {
            btnTitle: '保存',
            btnEvent: () => {},
            btnStyle: '',
          },
        ]
      },
    },
  },
  methods: {
    // 用于禁止冒泡
    noBubbles() {
      return
    },
  },
}
</script>

<style lang="scss" scope>
// 弹窗
.webmaster_popup_box {
  position: fixed;
  z-index: 1010;
  left: 0;
  top: 3.47vw;
  /* right: 0;
  bottom: 0; */
  width: 100vw;
  height: 100vh;
  background: var(--mixtmt_greyColor4);
  .webmaster_popup_item {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: var(--mixtmt_whiteColor);
    box-shadow: 0 0.1388vw 0.833vw 0 var(--mixtmt_greyColor5);
    border-radius: 0.278vw;
    border: 1px solid var(--mixtmt_greyColor7);
    min-height: 13.88vw;
    .webmaster_popup_close {
      position: absolute;
      right: -3.888vw;
      top: 0;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 2.5vw;
      height: 2.5vw;
      font-size: 1.25vw !important;
      color: var(--mixtmt_whiteColor);
      background: var(--mixtmt_greyColor4);
      border: 1px solid var(--mixtmt_whiteColor);
      border-radius: 50%;
      line-height: 2.083vw;
      cursor: pointer;
      & > i {
        font-size: 1.388vw;
      }
    }
    .webmaster_popup_title {
      width: 100%;
      height: 4.166vw;
      padding: 1.041vw;
      line-height: 2.083vw;
      font-size: 1.25vw;
      color: var(--mixtmt_greyColor3);
      text-align: center;
      font-weight: bold;
    }
    .webmaster_popup_body {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      max-height: calc(60vh - 8.333vw);
      padding: 0.694vw;
      overflow: auto;
      .popup_select_opt {
        top: 0 !important;
        left: 0 !important;
        position: absolute !important;
        margin-top: 4vw;
      }
    }
    .webmaster_popup_opra {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 4.166vw;
      padding: 1.041vw;
      .opraBtn {
        margin-left: 1.388vw;
        width: 8.33vw;
        height: 1.94vw;
        background: var(--mixtmt_mainColor6);
        color: var(--mixtmt_whiteColor);
        border: none;
        border-radius: 0.138vw;
        font-size: 0.833vw;
        font-weight: 500;
        line-height: 1.94vw;
        text-align: center;
        &:first-child {
          margin-left: 0;
          background: var(--mixtmt_whiteColor);
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }
}
</style>

<style lang="scss">
.webmaster_popup_box {
  .el-input__inner {
    height: 2.778vw;
    line-height: 2.778vw;
    border-radius: 0.278vw;
    padding: 0 1.041vw;
  }
  .el-select-dropdown {
    border-radius: 0.69vw;
  }
  .el-select-dropdown__item {
    font-size: 1.111vw;
    height: 2.778vw;
    line-height: 2.778vw;
    &.selected,
    &.hover,
    &.active,
    &.visited {
      color: var(--mixtmt_subColor1_1);
      background-color: var(--mixtmt_subColor1_2);
    }
  }
}
.mixtmt_pc {
  .webmaster_popup_opra {
    &.onlyBtn {
      .opraBtn {
        &:first-child {
          &:hover {
            background: var(--mixtmt_mainColor8);
            border: 1px solid var(--mixtmt_mainColor8);
            color: var(--mixtmt_whiteColor);
          }
        }
      }
    }
    .opraBtn {
      cursor: pointer;
      &:first-child {
        &:hover {
          background: var(--mixtmt_whiteColor);
          border: 1px solid var(--mixtmt_mainColor8);
        }
      }
      &:hover {
        background: var(--mixtmt_mainColor8);
      }
    }
  }
}
</style>
